/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 平台配置信息
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { AjaxBasics } from '../../helpers';
import PlatformConfig from '../../platform.config';
import { BaseModel } from '../bases';
@BindAll()
export class PlatformController {
  Model = new BaseModel({ type: 'object', storageKey: 'Platform' });
  @computed
  get PlatformConfig(): typeof PlatformConfig {
    return this.Model.get('PlatformConfig', PlatformConfig);
  }
  /**
   * @desc — 知名人物去世后 的 首页 背景灰色
   * @readonly
   * @memberof PlatformController
   */
  @computed
  get eventGray() {
    return this.PlatformConfig.home.eventGray;
  }
  /**
   * @desc — 促销活动 模块名称
   * @readonly
   * @memberof PlatformController
   */
  @computed
  get promotionTitle() {
    return this.PlatformConfig.home.promotionTitle;
  }
  /**
   * @desc — 智能推荐 模块名称
   * @readonly
   * @memberof PlatformController
   */
  @computed
  get referralTitle() {
    return this.PlatformConfig.home.referralTitle;
  }
  /**
   * 初始化 平台配置 小程序 同步调用的 PC&H5 不用
   * @memberof PlatformController
   */
  async InitPlatformConfig() {
    try {
      const config = await AjaxBasics.request('/platform.config.json');
      if (lodash.isObject(config) && !lodash.hasIn(config, 'errMsg')) {
        this.Model.merge({
          PlatformConfig: lodash.merge({}, PlatformConfig, config),
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
}
